import { HandleStatus, Status } from "../../../assets/data/Constants";
import { LatestProcedureInfoList } from "../../../type/apiType/IAPI_APP001";

/**
 * ボタン名取得部品
 * 「対応」に表示するボタン名を返却する
 * @param {LatestProcedureInfoList} data 手続履歴一覧参照API.最近の手続き履歴リスト
 * @returns {string} ボタン名
 */
const buttonName = (data: LatestProcedureInfoList): string => {
  if (data.handleStatus === HandleStatus["不要"]) return "戻す";

  if (data.handleStatus === HandleStatus["完了"]) {
    if (data.businessType === "JOB-79") {
      return "確認";
    }
    if (!data.applyId) return "";
    if (
      data.businessType === "JOB-11" &&
      data.latestApplyStatus === Status["処理完了"] &&
      data.resubmitButtonDisplayFlg === "1"
    )
      return "確認,取下";
    if (data.businessType === "JOB-45" || data.businessType === "JOB-80")
      return "";

    return "確認";
  }

  if (data.handleStatus === HandleStatus["取下"]) return "確認";

  if (data.handleStatus === HandleStatus["削除"]) return "";

  if (data.handleStatus === HandleStatus["差戻し"]) return "確認";

  return "";
};

export { buttonName };
